export function finishHtmlConsentBoot() {
  if (typeof document === 'undefined') {
    return;
  }
  document.documentElement.classList.remove(
    'wollzy-consent-pending',
    'wollzy-consent-boot-pending',
  );
  document.body.classList.remove('wollzy-consent-boot-active');
  const boot = document.getElementById('wollzy-consent-boot');
  if (boot) {
    boot.classList.add('is-done');
    boot.hidden = true;
  }
}

export function hasHtmlConsentBoot() {
  return (
    typeof window !== 'undefined' && Boolean(window.__WOLLZY_CONSENT_BOOT__)
  );
}

export function isHtmlConsentGiven() {
  return (
    typeof window !== 'undefined' && Boolean(window.__WOLLZY_CONSENT_GIVEN__)
  );
}
